// src/components/search/FormResultCard.tsx

import React from 'react';
import { Card, CardContent, Typography, Chip, Stack, Box, Button } from '@mui/material';
import { Description, Download } from '@mui/icons-material';
import { Form } from '@/types/form.types';

interface FormResultCardProps {
  form: Form;
  downloading: string | null;
  onDownload: (docUrl: string, fileName: string, isForm?: boolean) => void;
}

export const FormResultCard: React.FC<FormResultCardProps> = ({
  form,
  downloading,
  onDownload,
}) => (
  <Card sx={{ mb: 2, '&:hover': { boxShadow: 3 } }}>
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Description sx={{ color: 'secondary.main', mt: 0.5 }} />
        <Box flex={1}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
            {form.name}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            {form.type && (
              <Chip label={form.type} size="small" color="secondary" variant="outlined" />
            )}
            <Button
              size="small"
              startIcon={downloading === form.docUrl ? null : <Download />}
              onClick={() => onDownload(form.docUrl, form.name, true)}
              disabled={downloading === form.docUrl}
              variant="outlined"
            >
              {downloading === form.docUrl ? 'Descargando...' : 'Descargar'}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);
